import { render, staticRenderFns } from "./InfoTooltip.vue?vue&type=template&id=2049c7ff&scoped=true"
import script from "./InfoTooltip.vue?vue&type=script&lang=js"
export * from "./InfoTooltip.vue?vue&type=script&lang=js"
import style0 from "./InfoTooltip.vue?vue&type=style&index=0&id=2049c7ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2049c7ff",
  null
  
)

export default component.exports